import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AboutusService } from '../../services/aboutus.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { SearchService } from '../../services/search-service.service';
import { ProductService } from '../../services/productservice';
import { AuthenticationService } from '../../app/auth/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { Carousel } from 'primeng/carousel';
import { Product } from '../../services/product';
// import * as _ from 'lodash';
import { CanonicalService } from '../../services/canonical.service';
import { LoaderService } from '../../services/loader.service';
import { Title, Meta } from '@angular/platform-browser';
import CountriesList from 'flag-icons/country.json';
import { routeParamInfoItems } from '../home/home-route-param-info';

const ACT_WHATTODO: string = 'What to do';
const CAT_EVENTS: string = 'EVENT';
const CAT_TOUR: string = 'TOUR,TRANSPORT';
const CAT_ATTRACTIONS: string = 'ATTRACTION';
const CAT_ACCOMM: string = 'ACCOMM';
//const CAT_TESTIMONIAL: string = 'culture';
let attributes = 'TAGCreole-Rendezvous';
@Component({
  selector: 'app-creole',
  templateUrl: './creole.component.html',
  styleUrls: ['./creole.component.scss'],
  providers: [MessageService],
})
export class CreoleComponent implements OnInit {
  creoleCategories = [
    { label: 'Attractions', value: ['ATTRACTION'] },
    { label: 'General Services', value: ['GENSERVICE'] },
    { label: 'Food & Drinks', value: ['RESTAURANT'] },
    { label: 'Events', value: ['EVENT'] },
    { label: 'Tours', value: ['TOUR', 'TRANSPORT'] },
  ];
  selectedCategory: string[] = ['ATTRACTION'];
  activeIndex = 0;
  // searchCategories: any[] = [];
  filteredCategories: any[] = [];
  public creSpecialIntrest: any = { bannerImage: null, bannerTitle: null, bannerContent: null };
  public pageNumber: number = 1;
  public highLightPageNumber: number = 0;
  images: any = [];
  placesToSeeData: any;
  thingsToDoData: any;
  highlightsProducts: any;
  // wishlistData: any;
  whistlist: any;
  showLoader: boolean;
  TestMonialData: any[] = [];
  innerItems: Product[] = [];
  products: Product[];
  productCategory: any;
  filteredData: any;
  activityIcon: any;
  filterCategory: any;
  searchCategories: any;
  catName: any;
  responsiveOptions: any;
  lang: string;
  testimonialResponsive: any;
  beforeHeadingContent: string;
  videoProducts: any = [];
  secImages: any = [];
  public imageDisplayCustom: boolean;
  public imageActiveIndex: number = 0;

  @ViewChild('productsList') productsList: ElementRef;
  @Output() totalItems = new EventEmitter<any>();
  selectedCategorieName: any;
  searchDetails: any;
  originalSearchDetails: any;
  isClassifiedSelected = true;
  isLoading = false;
  test: any;
  listItem: any = [];
  catCls: any;
  minPrice: any = 0;
  maxPrice: any = 0;
  advanceSearchFilter: any = {
    starRatings: [],
    secretsRatings: [],
    landTypes: [],
    landCatTypes: [],
    amenities: [],
    price: [0, 0],
  };
  public selectedIslands: any = [];
  public selectedlandCategorys: any = [];
  public selectedFacilities: any = [];
  public refIslandList: any = [];
  public reflandCatType: any = [];
  public refamentsList: any = [];
  public isLandTypes: any = [];
  public islandCatTypes: any = [];
  public amentisTypes: any = [];
  currentUrl: any;
  sum: any;
  public moreIsland: boolean = true;
  public moreAmendments: boolean = true;
  selectedClassificationName: any;
  selectedAttributeName: any;
  selectedTag: any;
  public src = '../../../assets/images/NoImage.jpg';
  starRating: number = 4;
  totalRecords: any;
  location: any = [];
  islandBtns: any = [];
  tourData: any;
  public selectedCats: any = [];
  public classifications: string[] = [];
  public innerIsLandType: string;
  public searchItems: any;
  public searchResults: any = [];
  public isSearchResultsShow = false;
  public viewMoreDetails: any = [];
  wishlistData: any = [];
  bannerImage: any;
  selectedbannerCat: any;
  sortValue: string = 'newest';
  currentUser: any;
  sortOne: boolean = false;
  sortTwo: boolean = true;
  language: string;
  priceRange: any = undefined;
  public isViewMoreRecords: boolean;
  attributesDes: any;
  searchPrice?: number[];
  priceIncrement: number = 0;
  selectedCountry: any = {};
  countries: any = [];
  tourOperatorOptions: any = [];
  tourOperatorOptionSelected: any = 1;
  islandOptionSelected: any = 1;
  eventOptionSelected: any = 1;
  selectedCountries: any = [];
  displayCustom: boolean;
  selcat = '';
  eventBtns: any = [];
  public landCategory: any = [];
  public moreLandcategorys: boolean = true;
  fArr: any = [
    '24-hourreception',
    'dayspa',
    'freewi-fi',
    'paidwifi',
    'parentsroom',
    'swimmingpool',
    'bar',
    'barbeque',
    'boatramp',
    'café',
    'childrenhighchair',
    'children’splayroom',
    'children’spool',
    'conference/functionfacilities',
    'dailynewspapers',
    'deliveryavailable',
    'desk',
    'diningarea',
    'drivethroughsitesavailable',
    'dumppoint',
    'electriccooker',
    'electricvehiclechargingpoints',
    'familyfriendly',
    'foreigncurrencyexchange',
    'gamesorrecreationroom',
    'gas',
    'gascooker',
    'golfcourse',
    'gym',
    'kiosk',
    'laundry',
    'livemusic',
    'lounge',
    'openfireplace',
    'paytv',
    'outdoordiningarea',
    'outdoorfurniture',
    'playground',
    'privatediningarea',
    'privateveranda',
    'publictelephone',
    'radio/stereo',
    'restaurant',
    'roomsafe',
    'safe',
    'sewingkit',
    'spa/sauna',
    'suitablefunctions',
    'takeawayavailable',
    'tea/coffeefacility',
    'tenniscourt',
    'tourdesk',
    'umbrellas',
    'videogameconsole',
    'watersidedining',
  ];
  showTooltip = false;
  secretsRatings: any = [
    { code: 'BRONZE', name: 'bronze', description: 'Bronze' },
    { code: 'SILVER', name: 'sliver', description: 'Sliver' },
    { code: 'GOLD', name: 'gold', description: 'Gold' },
  ];
  starRatingValues: any = [
    { code: '1', name: '1', description: '1 Star' },
    { code: '2', name: '2', description: '2 Star' },
    { code: '3', name: '3', description: '3 Star' },
    { code: '4', name: '4', description: '4 Star' },
    { code: '5', name: '5', description: '5 Star' },
  ];
  rfArr: any = [
    'airconditioning',
    'alarmclock',
    'automatictellmachine',
    'baggageholdingroom',
    'privatepool',
    'bath',
    'bathrobes/slippers',
    'balcony',
    'dishwasher',
    'microwaveoven',
    'hairdryer',
    'telephone',
    'dryer',
    'flat-screentv',
    'kettle',
    'kitchenware',
    'minibar',
    'non-smoking',
    'oven',
    'refrigerator',
    'shower',
    'stovetop',
    'streamingservices',
    'television/radio',
    'toaster',
  ];
  facilitiesArr: any = [];
  roomFacilities: any = [];
  activitiesArr: any = [];
  AccreditationsArr: any = [
    {
      code: 'ACCREDITNSSC',
      name: 'ACCREDITNSSC',
      description: 'Sustainable Seychelles - Blue Recognition',
    },
    {
      code: 'ACCREDITNSSBRONZE',
      name: 'ACCREDITNSSBRONZE',
      description: 'Sustainable Seychelles - Bronze Recognition',
    },
    {
      code: 'ACCREDITNSSSILVER',
      name: 'ACCREDITNSSSILVER',
      description: 'Sustainable Seychelles - Silver Recognition',
    },
    {
      code: 'ACCREDITNSSGOLD',
      name: 'ACCREDITNSSGOLD',
      description: 'Sustainable Seychelles - Gold Recognition',
    },
    {
      code: 'ACCREDITNTSCL',
      name: 'ACCREDITNTSCL',
      description: 'Tourism Safe Certified Label',
    },
    {
      code: 'ACCREDITNWORKCATION',
      name: 'ACCREDITNWORKCATION',
      description: 'Workcation',
    },
  ];
  outdoorActivities = [
    'abseiling',
    'birdwatching',
    'boating',
    'camping',
    'canoeing/kayaking',
    'cycling',
    'fishing',
    'fourwheeldriving',
    'hanggliding/paragliding',
    'hiking',
    'horseriding',
    'mountainbiking',
    'rockclimbing',
    'sailing',
    'scenicdrives',
    'scubadiving',
    'snorkeling',
    'surfing',
    'swimming',
    'walks',
  ];

  constructor(
    public route: ActivatedRoute,
    public specialIntrestService: AboutusService,
    public router: Router,
    public searchService: SearchService,
    public productService: ProductService,
    public authenticationService: AuthenticationService,
    public messageService: MessageService,
    private translate: TranslateService,
    private titleService: Title,
    private elementRef: ElementRef,
    private loaderService: LoaderService,
    private meta: Meta,
    private canonicalService: CanonicalService
  ) {
    if (!JSON.parse(sessionStorage.getItem('loaded'))) {
      sessionStorage.setItem('loaded', JSON.stringify(true));
      window.location.reload();
    } else {
      sessionStorage.setItem('loaded', JSON.stringify(false));
    }
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.testimonialResponsive = [
      {
        breakpoint: '1024px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    this.activeIndex = 0;

    this.selectedCategory = ['ATTRACTION'];
    this.selectedCategorieName = 'ATTRACTION';
    this.selectedTag = 'TAGCreole-Rendezvous';
    this.searchByValue(this.pageNumber);
    this.beforeHeadingContent = this.translate.instant('PHENOMENAL');
    this.showLoader = true;
    this.lang = localStorage.getItem('language');
    this.creoleSpecialIntrest();
    this.placesToSeeModule();
    this.thingsToDoModule();
    //this.getBlogItems();
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      this.wishListDeatils();
    }
    //this.getTestiMonial();
    this.whatToDOTabs();
    this.productService.getActivitycategories().then((products) => {
      this.products = products;
      this.getItems(this.products[0]);
    });
    this.loadScripts();
    this.showLoader = false;
    this.canonicalService.createCanonicalURL();
    this.showLoader = true;
    this.currentUrl = this.router.url;
    const currentRoute = this.route.routeConfig?.path?.split('/')[0] ?? '';
    this.route.paramMap.subscribe((paramMap) => {
      const category = paramMap.get('category');
      this.selcat = category;
      const categoryInfo = routeParamInfoItems.find(
        (item) => item.route === currentRoute && item.routeParam === category
      );
      this.selectedCategorieName = categoryInfo?.cat;
      this.selectedClassificationName = categoryInfo?.cla?.includes(',')
        ? categoryInfo?.cla?.split(',')
        : categoryInfo?.cla;
      this.selectedAttributeName = categoryInfo?.['att'];
      this.selectedTag = categoryInfo?.tag;
      this.selectedbannerCat = categoryInfo?.bannerCat;

      if (this.selectedbannerCat) {
        this.getListType(this.selectedbannerCat);
      } else {
        this.getListType(this.selectedCategorieName);
      }
      this.getIslands();
      this.moreLandcategory();
      this.getAmenties();
      this.getCatInfo();
      if (this.selectedCategorieName === 'EVENT') {
        this.eventBtns = [
          {
            name: 'Events',
            img: '/assets/images/icon-events-green.png',
            imgSel: '/assets/images/icon-events-green.png',
            selected: true,
            code: 1,
          },
          {
            name: 'Deals & Offers',
            img: '/assets/images/icons-dealOffers-green-new.png',
            imgSel: '/assets/images/icons-dealOffers-green-new.png',
            selected: false,
            code: 2,
          },
        ];
      }
      if (this.selectedCategorieName === 'DESTINFO') {
        // Determine which tab should be selected based on classification
        const isBeachesSelected = this.selectedClassificationName === 'BEACHES';
        const isIslandsSelected = this.selectedClassificationName === 'ISLANDS';

        this.islandBtns = [
          {
            name: 'The Islands',
            img: '/assets/images/island.png',
            imgSel: '/assets/images/island.png',
            selected: isIslandsSelected,
            code: 1,
          },
          {
            name: 'Beaches',
            img: '/assets/images/beach.png',
            imgSel: '/assets/images/beach.png',
            selected: isBeachesSelected,
            code: 2,
          },
        ];

        // Set the option selected value based on classification
        if (isBeachesSelected) {
          this.islandOptionSelected = 2;
        } else {
          this.islandOptionSelected = 1;
        }
      }
      if (this.selectedCategorieName === 'TOUROPERATOR') {
        this.tourOperatorOptions = [
          {
            name: 'Local',
            img: '/assets/images/local.png',
            imgSel: '/assets/images/local-selected.png',
            selected: false,
            code: 1,
          },
          {
            name: 'International',
            img: '/assets/images/international.png',
            imgSel: '/assets/images/international-selected.png',
            selected: true,
            code: 2,
          },
        ];
        this.countries = CountriesList.sort((a: any, b: any) => {
          if (a.name > b.name) return 1;
          return -1;
        });
        this.countries = this.countries.filter((item: any) => item.name !== 'Unknown' && item.name !== 'Seychelles');
        this.selectedCountry = { name: 'Seychelles' };
        this.tourOperatorOptionChanged(1);
      } else {
        this.searchByValue();
      }
      if (this.selectedClassificationName) {
        this.isClassifiedSelected = false;
      } else {
        this.isClassifiedSelected = true;
      }

      this.findMinMax();
    });
  }
  loadScripts() {
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://starling.crowdriff.com/js/crowdriff.js';
    script.async = true;
    script.defer = true;
    script.id = 'cr-init__3df87fe29442b4ba';
    script.lang = this.lang.toLowerCase();
    const interval = setInterval(() => {
      var body = this.elementRef.nativeElement.querySelector('.creole');
      if (body) {
        body.appendChild(script);
        clearInterval(interval);
      }
    }, 1000);
  }
  creoleSpecialIntrest() {
    //creole banner image and content
    this.specialIntrestService.getCreoleSpecialIntrest().subscribe(
      (data) => {
        this.creSpecialIntrest = data;
        this.images.push(this.creSpecialIntrest.bannerImage);
        this.titleService.setTitle(this.creSpecialIntrest.bannerTitle + ' ' + '| The Seychelles Islands');
        // this.specialIntrestList.push(this.culSpecialIntrest);
        if (data.images) {
          this.secImages = [];
          for (let i = 0; i < data.images.length; i++) {
            this.secImages.push({ productImage: data.images[i], index: i });
          }
          //this.secImages = data.images;
          this.videoProducts = data.videos;
          setTimeout(() => {
            this.startVideo();
            let type = 'coverflow';
            if ($(window).width() <= 530) {
              type = 'flat';
            }
            ($('.latestvideos-flipster') as any).flipster({
              style: type,
              buttons: false,
              loop: true,
            });
          }, 1000);
        }
      },
      (err) => {
        console.error(err.message);
      }
    );
  }

  startVideo() {
    let containerWidth = $('.latestvideos-flipster').width();
    let width = 552;
    if (containerWidth > 500) {
      width = containerWidth / 2;
    }
    if (containerWidth <= 500) {
      width = containerWidth / 2;
    }
    // For mobile
    if ($(window).width() <= 530) {
      width = $(window).width();
    }
    let height = (width * 9) / 16;
    let players: any = [];
    this.videoProducts.forEach((item: any) => {
      let player = new window['YT'].Player(item, {
        videoId: item,
        height: height,
        width: width,
        origin: 'https://www.seychelles.com/',
        playerVars: {
          enablejsapi: 1,
          rel: 0,
          showinfo: 0,
          fs: 1,
          controls: 1,
          modestbranding: 1,
        },
        events: {
          onStateChange: function (event: any) {
            if (event.data == window['YT'].PlayerState.PLAYING) {
              ($('.latestvideos-flipster') as any).flipster('jump', $('#q' + event.target.getIframe().id));
              $.each(players, function (k: number, v: any) {
                if (
                  this.getPlayerState() == window['YT'].PlayerState.PLAYING &&
                  this.getIframe().id != event.target.getIframe().id
                ) {
                  this.stopVideo();
                }
              });
            }
          },
        },
      });
      players.push(player);
    });
  }
  getItems(item: any) {
    //Categories section
    this.productCategory = item.name;
    this.filteredData = this.innerItems.filter((product: any) => product.id === item.id);
    if (this.filteredData.length > 0) {
      if (this.filteredData[0].child[0]) {
        this.activityIcon = this.filteredData[0].child[0].iconUrl;
        this.filterCategory = this.filteredData[0].child[0].category;
        this.loadInnerChildData(this.filteredData[0].child[0].category);
      } else {
        console.log(' filteredData is null');
      }
    }
  }
  loadInnerChildData(category: any) {
    this.searchCategories = [];
    this.searchService
      .planYourVisitSearchListing(category, null, null, null, attributes, this.pageNumber)
      .subscribe((data) => {
        Array.from(data.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((dataq: any) => {
            mData.productName = dataq.productName;
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=460';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
        });
        this.searchCategories = data.products;
      });
  }
  whatToDOTabs() {
    this.productService.getWhatToDo().then((products) => {
      products = products.filter((item: any) => item.url !== '/walkandtrails' && item.url !== '/dealsandoffers');
      products.reverse();
      let item: Product = {
        id: 1,
        name: ACT_WHATTODO,
        description: 'What to do Description',
        child: this.formatValues(products, 1),
      };
      this.innerItems.push(item);
      if (this.innerItems) this.getItems(this.innerItems[0]);
    });
  }
  formatValues(items: Product[], index: number): Product[] {
    for (let i = 0; i < items.length; i++) {
      let category = null;
      if (index == 1) {
        //category = items[i].name === this.translate.instant('Events') ? CAT_EVENTS : CAT_TOUR;
        if (items[i].name == this.translate.instant('Events')) {
          category = CAT_EVENTS;
        }
        if (items[i].name == this.translate.instant('Activities')) {
          category = CAT_TOUR;
        }
      } else if (index == 2) {
        category = CAT_ATTRACTIONS;
      } else {
        category = CAT_ACCOMM;
      }
      let item: Product = items[i];
      item.category = category;
    }
    return items;
  }
  getChildItems(child: any) {
    if (child.name == this.translate.instant('Walks and Trails')) {
      this.searchService
        .planYourVisitSearchListing('', null, 'WBTOURS,TRAIL', null, attributes, this.pageNumber)
        .subscribe((data) => {
          Array.from(data.products).map(async (mData: any) => {
            await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((dataq: any) => {
              mData.productName = dataq.productName;
            });
            if (mData.productImage) {
              let img = mData.productImage.split('&');
              img[1] = 'fit=crop&w=460';
              img[2] = 'h=600';
              mData.productImage = img.join('&');
            }
          });
          this.searchCategories = data.products;
        });
      this.catName = child.name;
      this.activityIcon = child.iconUrl;
    } else if (child.name == this.translate.instant('Activities')) {
      this.filterCategory = child.category;
      this.activityIcon = child.iconUrl;
      this.catName = child.name;
      this.loadInnerChildData(child.category);
    } else {
      this.activityIcon = child.iconUrl;
      this.filterCategory = child.category;
      this.loadInnerChildData(child.category);
    }
  }
  viewAllPlacesToSee() {
    if (this.catName == this.translate.instant('ATTRACTION')) {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/experience', 'attractions']));
    }
  }
  viewAllCategoryItems() {
    if (this.catName == this.translate.instant('Walks and Trails')) {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/experience', 'walksandtrails']));
    } else if (this.catName == this.translate.instant('Activities')) {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/experience', 'activities']));
    } else {
      this.router.navigate(['/experience', 'events']);
    }
  }
  placesToSeeModule() {
    this.searchService
      .planYourVisitSearchListing('ATTRACTION', null, null, null, attributes, this.pageNumber)
      .subscribe((data) => {
        Array.from(data.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((dataq: any) => {
            mData.productName = dataq.productName;
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
          this.currentUser = this.authenticationService.currentUserValue;
          if (this.currentUser) {
            await this.searchService.getWishList().subscribe((wishlistData) => {
              Array.from(wishlistData).map((attData: any) => {
                if (mData.productId == attData.field_product_id) {
                  mData.wishlist = 'true';
                  //mData.color = '#00a7a6';
                  mData.color = '#e94363';
                }
              });
            });
          }
        });

        this.placesToSeeData = data.products;
        if (this.placesToSeeData && this.placesToSeeData.length == 1) {
          this.placesToSeeData.push({ productName: '' });
          this.placesToSeeData.push({ productName: '' });
          this.placesToSeeData.push({ productName: '' });
        }
        if (this.placesToSeeData && this.placesToSeeData.length == 2) {
          this.placesToSeeData.push({ productName: '' });
          this.placesToSeeData.push({ productName: '' });
        }
        if (this.placesToSeeData && this.placesToSeeData.length == 3) {
          this.placesToSeeData.push({ productName: '' });
        }
      });
  }

  thingsToDoModule() {
    this.searchService
      .planYourVisitSearchListing('EVENT,TOUR', null, 'WBTOURS,TRAIL', null, attributes, this.pageNumber)
      .subscribe((data) => {
        Array.from(data.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((dataq: any) => {
            mData.productName = dataq.productName;
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
          this.currentUser = this.authenticationService.currentUserValue;
          if (this.currentUser) {
            await this.searchService.getWishList().subscribe((wishlistData) => {
              Array.from(wishlistData).map((attData: any) => {
                if (mData.productId == attData.field_product_id) {
                  mData.wishlist = 'true';
                  //mData.color = '#00a7a6';
                  mData.color = '#e94363';
                }
              });
            });
          }
        });
        this.thingsToDoData = data.products;
      });
  }

  getCategoryItems(category: any) {
    var url = '/listingdetails/' + category.productId;
    window.open(url, '_blank');
  }

  addToWhishList(item: any) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      this.wishListDeatils();
      const prodcut = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
      if (prodcut) {
        const wishlist = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
        if (wishlist) {
          this.searchService.removeWishListDeatils(wishlist.nid).subscribe(
            (data) => {
              // this.whistlist = this.whistlist.filter((product: any) => product.productId !== item.productId);
              item.color = '#bbbbbb';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Remove-Successfull'),
              });
              this.wishListDeatils();
            },
            (err) => {
              this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
            }
          );
        }
      } else {
        this.wishListDeatils();
        if (this.wishlistData.length >= 10) {
          this.messageService.add({
            key: 'add-wishlist',
            severity: 'info',
            summary: 'Info',
            detail: this.translate.instant('WhishList-Exceed-Message'),
          });
        } else {
          this.searchService.postWishList(item.productId, 'driving', []).subscribe((result: any) => {
            if (result) {
              //item.color = '#00a7a6';
              item.color = '#e94363';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Add-Successfull'),
              });
              this.wishListDeatils();
            }
          });
        }
      }
    } else {
      this.messageService.add({
        key: 'add-wishlist',
        severity: 'info',
        summary: 'Info',
        detail: this.translate.instant('WhishList-Login-Alert'),
      });
    }
  }
  wishListDeatils() {
    //get wishlist details
    this.searchService.getWishList().subscribe((wishlistData) => {
      const productItem = wishlistData.map((productId: any) => `"${productId.field_product_id}"`).join(',');
      this.wishlistData = wishlistData;
      if (productItem !== '') {
        this.searchService.wishListDeatils(productItem).subscribe((data) => {
          this.whistlist = data.products;
          // this.searchService.getWishList().subscribe((wishlistData) => {
          //   this.wishlistData=[];
          //   this.wishlistData = wishlistData;
          //   console.log("wish",this.wishlistData)
        });
      }
    });
  }
  scollBottom() {
    window.scrollTo({
      top: 540,
      behavior: 'smooth',
    });
  }
  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  imageItemClick(index: number) {
    this.imageActiveIndex = index;
    this.imageDisplayCustom = true;
  }

  prev() {
    ($('.latestvideos-flipster') as any).flipster('prev');
  }

  next() {
    ($('.latestvideos-flipster') as any).flipster('next');
  }

  async getIslands() {
    if (this.selectedClassificationName === 'ISLANDS') {
      await this.searchService
        //.islandTypes(this.selectedCategorieName, this.selectedClassificationName)
        .islandTypes(this.selectedCategorieName, 'BEACHES')
        .subscribe((data: any) => {
          this.isLandTypes = [];
          this.isLandTypes = data.facetGroups.facetGroupFields;
          if (data.facetGroups.facetGroupFields) {
            if ('BEACHES' === 'BEACHES') {
              this.isLandTypes = data.facetGroups.facetGroupFields.filter((item: any) => item.name != '');
            }
          }
        });
    } else {
      await this.searchService
        .islandTypes(this.selectedCategorieName, this.selectedClassificationName)
        .subscribe((data: any) => {
          this.isLandTypes = [];
          this.isLandTypes = data.facetGroups.facetGroupFields;
          if (data.facetGroups.facetGroupFields) {
            this.isLandTypes = data.facetGroups.facetGroupFields.filter((item: any) => item.name != '');
          }
        });
    }
  }

  moreLandcategory() {
    this.landCategory = [
      { id: 'Inner', name: 'Inner Islands' },
      { id: 'Outer', name: 'Outer Islands' },
    ];
    this.moreLandcategorys = false;
  }

  async getAmenties() {
    this.searchService.getAttributes().then((attributes) => {
      if (attributes) {
        this.attributesDes = attributes[1].Attributes;
        if (this.selectedCategorieName == 'ACCOMM') {
          const vals = attributes[0].Attributes;
          vals.forEach((item: any) => {
            let description = item.Description;
            let formattedDescription = description.toLowerCase().replace(/\s/g, '');
            if (this.outdoorActivities.includes(formattedDescription)) {
              this.activitiesArr.push({
                code: 'ACTIVITY' + item.AttributeId,
                name: 'ACTIVITY' + item.AttributeId,
                description: description,
              });
            }
          });

          this.attributesDes.forEach((item: any) => {
            let description = item.Description;
            let formattedDescription = description.toLowerCase().replace(/\s/g, '');
            if (this.fArr.includes(formattedDescription)) {
              this.facilitiesArr.push({
                code: 'ENTITYFAC' + item.AttributeId,
                name: 'ENTITYFAC' + item.AttributeId,
                description: description,
              });
            } else if (this.rfArr.includes(formattedDescription)) {
              this.roomFacilities.push({
                code: 'ENTITYFAC' + item.AttributeId,
                name: 'ENTITYFAC' + item.AttributeId,
                description: description,
              });
            }
          });
        } else {
          this.searchService
            .ameniesTypes(this.selectedCategorieName, this.selectedClassificationName)
            .subscribe(async (data: any) => {
              let amentiesArray: any = [];
              if (data.facetGroups.facetGroupFields) {
                //this.amentisTypes = data.facetGroups.facetGroupFields;
                Array.from(data.facetGroups.facetGroupFields).map(async (attData: any) => {
                  if (attData.name.startsWith('ENTITYFAC')) {
                    let [prefix, amentiesId] = attData.name.split('ENTITYFAC');
                    if (this.attributesDes) {
                      let res = this.attributesDes.filter((product: any) => {
                        if (product.AttributeId == amentiesId) return product.Description;
                      });
                      if (res && res.length > 0) {
                        attData.Description = res[0].Description;
                        amentiesArray.push(attData);
                      }
                    }
                  }
                });
                this.amentisTypes = amentiesArray;
              }
            });
        }
      }
    });
  }

  sort(event: string) {
    if (event) {
      //this.sortValue = event;
      this.pageNumber = 1;
      this.searchByValue(this.pageNumber);
    }
  }

  // ... inside PlanyourvisitCategoriesComponent class

  advanceSearch(event: any, search: any) {
    // search is this.advanceSearchFilter
    this.pageNumber = 1;
    event.preventDefault();
    console.log('Advance search applied with filters:', search);

    // Clear previous land/amenity lists before repopulating
    this.refIslandList = [];
    this.reflandCatType = [];
    this.refamentsList = [];

    if (search.landTypes.length > 0) {
      this.refIslandList = search.landTypes.map((landTypes: any) => landTypes.name).join(',');
    }
    if (search.landCatTypes.length > 0) {
      this.reflandCatType = search.landCatTypes.map((landCatTypes: any) => landCatTypes.name).join(',');
    }
    if (search.amenities.length > 0) {
      this.refamentsList = search.amenities.map((amenities: any) => amenities.name).join(',');
    }

    // --- START MODIFICATION for this.searchPrice ---
    const selectedMinPrice = search.price[0];
    const selectedMaxPrice = search.price[1];
    const overallMinDatasetPrice = this.minPrice.rateFrom; // Min price from the current dataset (ignoring price filter itself)
    const overallMaxDatasetPrice = this.maxPrice.rateTo; // Max price from the current dataset

    let isPriceFilterActiveByUser = false;

    // If maxPrice.rateTo is 0, it means there are no prices in the dataset, so skip price filtering
    if (overallMaxDatasetPrice === 0) {
      console.log('maxPrice.rateTo is 0. No price filtering will be applied.');
      isPriceFilterActiveByUser = false;
    } else if (selectedMaxPrice > 0) {
      // If the selected range is [0, overallMaxDatasetPrice] AND the dataset's min is indeed 0,
      // this means the user hasn't constrained the price from the default "all items from 0 up to max".
      // In this specific case, we might consider it "not an active user selection" for sending parameters.
      if (selectedMinPrice === 0 && overallMinDatasetPrice === 0 && selectedMaxPrice === overallMaxDatasetPrice) {
        console.log(
          'Price filter is at default [0, max_in_dataset]. Treating as no explicit price filter by user for API params.'
        );
        isPriceFilterActiveByUser = false;
      } else {
        // Any other selection where max > 0 is an active filter.
        // E.g., [50, 100], or [0, 200] when overallMax is 500, or [50, overallMax]
        isPriceFilterActiveByUser = true;
      }
    } else if (selectedMinPrice === 0 && selectedMaxPrice === 0) {
      // User selected [0,0]. This is a specific filter for "free" items.
      isPriceFilterActiveByUser = true;
    }
    // Else (selectedMaxPrice is 0, and selectedMinPrice is > 0 (invalid range) or other edge cases),
    // isPriceFilterActiveByUser remains false.

    if (isPriceFilterActiveByUser) {
      this.searchPrice = [...search.price]; // Use spread to make a copy
      this.priceRange = this.searchPrice[1] + 1; // Your existing logic for priceRange
      console.log('User has actively selected a price filter:', this.searchPrice);
    } else {
      this.searchPrice = undefined;
      this.priceRange = undefined;
      console.log(
        'No active price filter selected by user, or it matches default [0, max_in_dataset]. `searchPrice` is undefined.'
      );
    }
    // --- END MODIFICATION for this.searchPrice ---

    this.searchByValue(this.pageNumber);
    this.toggleFilter();
  }

  // Also, ensure `restChange` correctly clears `this.searchPrice`
  restChange() {
    this.refamentsList = 'TAGCreole-Rendezvous';
    this.selectedTag = 'TAGCreole-Rendezvous'; // optional backup
    // this.refamentsList = '';
    this.classifications = []; // Assuming this should be cleared
    this.refIslandList = '';
    this.reflandCatType = ''; // Clear this as well if it's part of filters

    // Reset advanceSearchFilter to its initial state, especially the price
    // This ensures the slider and inputs go back to the overall min/max
    this.advanceSearchFilter = {
      starRatings: [],
      secretsRatings: [],
      landTypes: [],
      landCatTypes: [],
      amenities: [],
      price: [this.minPrice.rateFrom, this.maxPrice.rateTo], // Reset to full range
      landCategory: [], // Assuming this was also a filter
    };

    this.searchPrice = undefined; // Crucial for clearing applied price filter
    this.priceRange = undefined; // Clear related priceRange variable

    this.selectedTag = 'TAGCreole-Rendezvous';
    this.pageNumber = 1;
    this.searchByValue(this.pageNumber);

    // this.searchByValue(); // Refresh results
    this.toggleFilter(); // Close filter UI
  }

  selectedClassification(classificationItem: any) {
    const itemIndex = this.classifications.indexOf(classificationItem.ProductTypeId);
    if (itemIndex > -1) {
      this.classifications.splice(itemIndex, 1);
    } else {
      this.classifications.push(classificationItem.ProductTypeId);
    }
  }

  getListType(selectedCat: any) {
    this.searchService.getListType(selectedCat).subscribe((data) => {
      let refListItem = data;
      this.listItem = [];
      this.listItem.push(refListItem);
      if (this.listItem[0].bannerImage) {
        this.bannerImage = this.listItem[0].bannerImage;
      } else {
        this.bannerImage = '../../../assets/images/NoImage.jpg';
      }
      this.images.push(this.bannerImage);
      //console.log(data)
      if (data.metaTitle) {
        this.meta.updateTag({ name: 'title', content: data.metaTitle });
        this.titleService.setTitle(data.metaTitle);
      } else {
        this.titleService.setTitle(this.listItem[0].bannerTitle + ' ' + '| The Seychelles Islands');
      }
      if (data.metaKeywords) {
        this.meta.updateTag({ name: 'keywords', content: data.metaKeywords });
      }
      if (data.metaDescription) {
        this.meta.updateTag({ name: 'description', content: data.metaDescription });
      }
      //Added this codition for URL links open in the New Tab
      if (data.content) {
        data.content = data.content.replace(/<a\s+href=["'][^"']*["']/g, (match: string) => {
          return match.includes('target=') ? match : match + ' target="_blank"';
        });
      }
    });
  }

  getCatInfo() {
    // let url = this.router.url.split('?');
    if (
      this.selectedbannerCat == 'getting-around' &&
      Array.isArray(this.selectedClassificationName) &&
      ['BICYCLE', 'BOAT', 'CAR', 'EQUIP', 'MINBUSCOAC', 'YACHT', 'BUSSVC', 'COACHSVC', 'FERRYSVC', 'TAXI'].every(
        (val) => this.selectedClassificationName.includes(val)
      )
    ) {
      this.searchService.getCatInfo('HIRE,TRANSPORT').subscribe((data) => {
        this.catCls = [];
        this.catCls = data;
        this.isClassifiedSelected = true;
      });
    } else {
      this.searchService.getCatInfo(this.selectedCategorieName).subscribe((data) => {
        this.catCls = [];
        this.catCls = data;
        if (this.selectedbannerCat && this.selectedbannerCat === 'getting-around') {
          this.isClassifiedSelected = true;
          this.catCls = [
            { Description: 'Bicycles', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'BICYCLE' },
            { Description: 'Boats', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'BOAT' },
            { Description: 'Cars', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'CAR' },
            { Description: 'Taxi', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'TAXI' },
            { Description: 'Yachts', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'YACHT' },
            { Description: 'Equipment', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'EQUIP' },
            { Description: 'Bus Services', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'BUSSVC' },
            { Description: 'Coach Services', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'COACHSVC' },
            { Description: 'Ferry Services', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'FERRYSVC' },
            { Description: 'Domestic Air Services', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'DOMAIRSVC' },
            { Description: 'Minibuses and Coaches', ProductCategory: 'GETTINGAROUND', ProductTypeId: 'MINBUSCOAC' },
          ];
        }
      });
    }
  }

  islandOptionChanged(val: any) {
    this.priceIncrement = 0;
    this.pageNumber = 1;
    if (val == 2) {
      this.islandBtns[1].selected = true;
      this.islandBtns[0].selected = false;
      this.selectedClassificationName = 'BEACHES';
    } else {
      this.islandBtns[1].selected = false;
      this.islandBtns[0].selected = true;
      this.selectedClassificationName = 'ISLANDS';
    }
    this.refamentsList = '';
    this.classifications = [];
    this.refIslandList = '';
    this.reflandCatType = '';
    this.advanceSearchFilter = {
      landTypes: [],
      landCatTypes: [],
      amenities: [],
      price: [this.minPrice.rateFrom, this.maxPrice.rateTo],
    };
    this.searchPrice = undefined;
    this.searchByValue();
  }

  eventOptionChanged(val: any) {
    this.priceIncrement = 0;
    this.pageNumber = 1;
    if (val == 2) {
      this.router.navigate([], { queryParams: { tag: 'TAGDeals-Offers' } });
      this.eventBtns[1].selected = true;
      this.eventBtns[0].selected = false;
      this.selectedCategorieName = '';
      this.refamentsList = 'TAGDeals-Offers';
      this.searchByValue();
    } else {
      this.router.navigate([], { queryParams: {} });
      this.eventBtns[1].selected = false;
      this.eventBtns[0].selected = true;
      this.selectedCategorieName = 'EVENT';
      this.refamentsList = '';
      setTimeout(() => {
        this.searchByValue();
      }, 1000);
    }

    this.classifications = [];
    this.refIslandList = '';
    this.reflandCatType = '';
    this.advanceSearchFilter = {
      landTypes: [],
      landCatTypes: [],
      amenities: [],
      price: [this.minPrice.rateFrom, this.maxPrice.rateTo],
    };
    this.searchPrice = undefined;
    // this.searchByValue();
  }

  tourOperatorOptionChanged(val: any) {
    this.priceIncrement = 0;
    this.pageNumber = 1;
    if (val == 2) {
      this.tourOperatorOptions[1].selected = true;
      this.tourOperatorOptions[0].selected = false;
      if (this.selectedCountry && this.selectedCountry.name == 'Seychelles') {
        this.selectedCountry = { name: 'nonseychelles' };
      }
    } else {
      this.tourOperatorOptions[1].selected = false;
      this.tourOperatorOptions[0].selected = true;
      this.selectedCountry = { name: 'Seychelles' };
    }
    this.refamentsList = '';
    this.classifications = [];
    this.refIslandList = '';
    this.reflandCatType = '';
    this.advanceSearchFilter = {
      landTypes: [],
      landCatTypes: [],
      amenities: [],
      price: [this.minPrice.rateFrom, this.maxPrice.rateTo],
    };
    this.searchPrice = undefined;
    this.searchByValue();
  }

  countrySelected() {
    if (!this.selectedCountry && this.tourOperatorOptions[1].selected) {
      this.selectedCountry = { name: 'nonseychelles' };
    }
    this.searchByValue();
  }

  findMinMax() {
    if (
      !this.selectedCategorieName ||
      this.selectedCategorieName === '' ||
      !this.refamentsList ||
      this.refamentsList === ''
    ) {
      console.log('Skipping findMinMax API call');
      return;
    }
    let claNames = this.selectedClassificationName;
    if (this.selectedbannerCat && this.selectedbannerCat === 'getting-around') {
      if (this.classifications.length) {
        claNames = [];
      }
    }
    let countryName = '';
    if (this.selectedCategorieName === 'TOUROPERATOR' && this.selectedCountry && this.selectedCountry.name) {
      countryName = this.selectedCountry.name.toLowerCase();
    }
    this.searchService
      .findMinMaxService(
        this.selectedCategorieName,
        claNames,
        this.classifications.join(','),
        this.refIslandList,
        this.refamentsList,
        // this.selectedAttributeName,
        this.pageNumber,
        this.searchPrice,
        this.selectedTag,
        countryName,
        this.advanceSearchFilter.landCategory
      )
      .subscribe((data: any) => {
        if (data && data.products.length > 0) {
          let searchResults = data.products;
          let minValues = searchResults.map(function (v: any) {
            if (v.rateFrom && v.rateFrom !== '') {
              return v.rateFrom;
            } else {
              return 1000000000000000000;
            }
          });
          var min = Math.min.apply(null, minValues);
          // Added condition for to show minimum value 0
          if (minValues.includes(min)) {
            min = 0;
          }
          let maxValues = searchResults.map(function (v: any) {
            if (v.rateTo && v.rateTo !== '') {
              return v.rateTo;
            } else {
              return 0;
            }
          });
          var max = Math.max.apply(null, maxValues);
          this.maxPrice = { rateTo: max };
          this.minPrice = { rateFrom: min };
          this.advanceSearchFilter.price = [min, max];

          // If max price is 0, ensure searchPrice is undefined so no price filter is sent to API
          if (max === 0) {
            this.searchPrice = undefined;
          }
        }
      });
  }

  getSortOptions(sortVal: string): { sortBy: string; sortOrder: 'asc' | 'desc' } {
    switch (sortVal) {
      case 'A to Z':
        return {
          sortBy: 'product_name',
          sortOrder: 'asc',
        };
      case 'Z to A':
        return {
          sortBy: 'product_name',
          sortOrder: 'desc',
        };
      case 'newest':
        return {
          sortBy: 'product_update_date',
          sortOrder: 'desc',
        };
      case 'oldest':
        return {
          sortBy: 'product_update_date',
          sortOrder: 'asc',
        };
      case 'price_low':
        return {
          sortBy: 'rate_from',
          sortOrder: 'asc',
        };
      case 'price_high':
        return {
          sortBy: 'rate_from',
          sortOrder: 'desc',
        };
      case 'rating_low':
        return {
          sortBy: 'star_rating',
          sortOrder: 'asc',
        };
      case 'rating_high':
      default:
        return {
          sortBy: 'star_rating',
          sortOrder: 'desc',
        };
    }
  }

  searchByValue(pageNumber?: number, isViewMore?: boolean) {
    this.route.queryParamMap.subscribe((params) => {
      if (params.get('tag') === 'TAGDeals-Offers') {
        this.selectedCategorieName = '';
        this.refamentsList = 'TAGDeals-Offers';
        this.eventOptionSelected = 2;
        this.eventBtns[1].selected = true;
        this.eventBtns[0].selected = false;
      }
    });
    this.isLoading = false;
    this.showLoader = true;
    let claNames = this.selectedClassificationName;
    if (this.selectedbannerCat && this.selectedbannerCat === 'getting-around') {
      if (this.classifications.length) {
        claNames = [];
      }
    }
    let countryName = '';
    if (this.selectedCategorieName === 'TOUROPERATOR' && this.selectedCountry && this.selectedCountry.name) {
      countryName = this.selectedCountry.name.toLowerCase();
    }
    if (this.sortValue === undefined) {
      this.sortValue = 'newest';
    }
    const { sortBy, sortOrder } = this.getSortOptions(this.sortValue);
    // Default category on page refresh
    if (!this.selectedCategorieName || this.selectedCategorieName === '') {
      this.selectedCategorieName = 'ATTRACTION';
    }

    // Default tag
    if (!this.refamentsList || this.refamentsList === '') {
      this.refamentsList = 'TAGCreole-Rendezvous';
    }
    //Added for price range equal data
    let priceFilterEqual: any = undefined;
    console.log(this.searchPrice);
    if (this.searchPrice) {
      priceFilterEqual = [];
      priceFilterEqual[0] = this.searchPrice[0];
      priceFilterEqual[1] = this.searchPrice[1] + 1;
    }

    // console.log('API PARAMS =>000000000000000000000000000000000000000', {
    // cats: this.selectedCategorieName,
    // att: this.selectedTag
    // });
    if (!this.selectedTag) {
      this.selectedTag = 'TAGCreole-Rendezvous';
    }
    return this.searchService
      .planYourVisitSearchListing(
        this.selectedCategorieName,
        claNames,
        this.classifications.join(','),
        this.refIslandList,
        this.refamentsList,
        // this.selectedAttributeName,
        pageNumber,
        priceFilterEqual,
        this.selectedTag,
        countryName,
        this.advanceSearchFilter.landCategory,
        null,
        sortBy,
        sortOrder,
        this.advanceSearchFilter
      )
      .toPromise()
      .then((data) => {
        if (this.selectedCategorieName === 'EVENT' && this.sortValue == 'oldest') {
          data.products.sort((a: any, b: any) => {
            // Skip sorting if either value is empty
            if (!a.nextOccurrence || !b.nextOccurrence) return 0;

            const dateA = new Date(a.nextOccurrence).getTime();
            const dateB = new Date(b.nextOccurrence).getTime();

            // Skip sorting if either date is invalid
            if (isNaN(dateA) || isNaN(dateB)) return 0;

            return dateB - dateA;
          });
        }
        this.searchItems = data;
        console.log(data);
        this.currentUser = this.authenticationService.currentUserValue;
        if (this.currentUser) {
          this.searchService.getWishList().subscribe((wishlistData) => {
            Array.from(wishlistData).map((attData: any) => {
              Array.from(this.searchItems.products).map(async (mData: any) => {
                if (mData.productId == attData.field_product_id) {
                  mData.wishlist = 'true';
                  // mData.color = '#00a7a6';
                  mData.color = '#e94363';
                }
              });
            });
          });
        }
        Array.from(this.searchItems.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetails(mData.productId).subscribe((data: any) => {
            mData.createdAt = data.createdDate;
            if (data.secrateRating) {
              mData['secrateRating'] = data.secrateRating;
            } else {
              mData['secrateRating'] = 'NONE';
            }

            if (data.frequencyStartDate && data.frequencyStartDate != '') {
              const sDate = new Date(data.frequencyStartDate + 'T00:00:00');
              const startDate = sDate.getDate();
              const startRm = ['st', 'nd', 'rd'][(startDate % 10) - 1] || 'th';
              mData['startDate'] = sDate;
              mData['startRm'] = startRm;

              if (data.frequencyStartDate == data.frequencyEndDate) {
                mData['endDate'] = 'none';
              } else {
                const eDate = new Date(data.frequencyEndDate + 'T00:00:00');
                const endDate = eDate.getDate();
                const endRm = ['st', 'nd', 'rd'][(endDate % 10) - 1] || 'th';
                mData['endDate'] = eDate;
                mData['endRm'] = endRm;
              }
            } else {
              mData['startDate'] = 'none';
            }
            mData['showItem'] = true;
            mData.productName = data.productName;
            //console.log(mData);
            if (data.attributes) {
              mData.accredations = [];
              Array.from(data.attributes).map((attData: any) => {
                if (attData.categoryType === 'EVENT') {
                  if (attData.attributeId === 'Deals&Offers') {
                    if (this.refamentsList !== 'TAGDeals-Offers') {
                      mData.showItem = false;
                    }
                  }
                }
                if (attData.attributeTypeId === 'ACCREDITN') {
                  mData.accrdIn = 'true';
                }
                if (
                  attData.attributeTypeId === 'ACCREDITN' &&
                  (attData.attributeId === 'SSTL' || attData.attributeId === 'SSC')
                ) {
                  mData.accredations.push('../../../assets/images/ssblue.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSBRONZE') {
                  mData.accredations.push('../../../assets/images/ssbronze.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSGOLD') {
                  mData.accredations.push('../../../assets/images/ssgold.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSLIVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSILVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                // if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'UAA') {
                // data.accredations.push('../../../assets/images/home-slick-slider-3.jpg');
                // }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'TSCL') {
                  mData.accredations.push('../../../assets/images/safe-label.jpg');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'WORKCATION') {
                  mData.accredations.push('../../../assets/images/workcation.jpg');
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  data.starRating = -1;
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  mData.starRating = -1;
                }
              });

              this.AccreditationsArr = Array.from(
                new Set(this.AccreditationsArr.map((item: any) => item.description))
              ).map((description) => {
                return this.AccreditationsArr.find((item: any) => item.description === description);
              });
            }
            if (data.productTypes) {
              mData.classification = [];
              var language = localStorage.getItem('language');
              Array.from(data.productTypes).map((attData: any) => {
                if (attData.productTypeDescriptionMv && attData.productTypeDescriptionMv !== '' && language !== 'EN') {
                  attData.productTypeDescription = attData.productTypeDescriptionMv.replace('&amp;', '&');
                } else {
                  attData.productTypeDescription = attData.productTypeDescription.replace('&amp;', '&');
                }
                mData.classification.push(attData.productTypeDescription);
              });
            }
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=460';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
          mData.accrdIn = 'false';
          // mData.starRating = '-1';
        });

        this.totalRecords = this.searchItems.numberOfResults;
        let noOfPages = this.totalRecords / 12;
        if (noOfPages) {
          if (this.pageNumber <= noOfPages) this.isViewMoreRecords = true;
          else this.isViewMoreRecords = false;
        } else {
          this.isViewMoreRecords = false;
        }
        if (isViewMore) {
          for (var i = 0; i < this.searchItems.products.length; i++) {
            this.searchResults.push(this.searchItems.products[i]);
          }
          this.isSearchResultsShow = true;
        } else {
          this.searchResults = [];
          this.searchResults = this.searchItems.products;
          this.isSearchResultsShow = true;
        }
        this.searchResults = this.searchResults.filter((item: any) => item.productName !== 'test-kat-88');
        // Added this if condition for low to high filter.
        if (sortBy === 'rate_from' && sortOrder === 'asc') {
          let products = this.searchResults;
          products.sort((item1: any, item2: any) => {
            if (item1.rateFrom === undefined || item1.rateFrom === null) {
              return -1;
            }
            if (item2.rateFrom === undefined || item2.rateFrom === null) {
              return 1;
            }
            return item1.rateFrom - item2.rateFrom;
          });
        }
        this.searchResults.forEach((el: any) => {
          if (el.productDescription.length > 30) {
            el.productDescription = el.productDescription.substr(0, 100) + '...';
          }
          el.addresses.forEach((ele: any) => {
            if (ele.address_type == 'PHYSICAL') {
              el.island = ele.island;
            }
          });
        });
        this.isLoading = true;
        this.showLoader = false;
      })
      .catch((err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
        this.showLoader = false;
      });
  }

  sstlText(item: any, accr: any) {
    const sustainabilityMap = {
      ssblue: 'Blue',
      ssgold: 'Gold',
      sssliver: 'Silver',
      sssilver: 'Silver',
      ssbronze: 'Bronze',
    };
    let val = 'Blue';
    for (const [code, value] of Object.entries(sustainabilityMap)) {
      if (accr.includes(code)) {
        val = value;
      }
    }
    // If any matching accreditation was found, return formatted HTML
    if (val) {
      const html = `<div style='color:#399;font-weight:bold;'>Sustainable Seychelles - ${val} Recognition</div>`;
      const htmlr =
        '<div>This Sustainable Seychelles rating is provided to Seychelles.com by the Seychelles Tourism Department, and is usually determined by a committee and adherence to set criteria.</div>';

      return html + htmlr;
    }

    return '';
  }

  isSustainableSeychelles(accr: string): boolean {
    const sustainableTypes = ['ssblue', 'ssgold', 'sssliver', 'ssbronze', 'sssilver'];
    return sustainableTypes.some((type) => accr.includes(type));
  }

  secrateRatingText(item: any) {
    let val = 'Gold';
    if (item.secrateRating == 'SILVER') {
      val = 'Silver';
    }
    if (item.secrateRating == 'BRONZE') {
      val = 'Bronze';
    }
    const html = "<div style='color:#399;font-weight:bold;'>Seychelles Secrets - " + val + '</div>';
    const htmlr =
      '<div>This Seychelles Secrets rating is provided to Seychelles.com by the Seychelles Tourism Department and is determined by the Seychelles Tourism Grading Programme.</div>';

    return html + htmlr;
  }

  starRatingText(item: any) {
    const html = "<div style='color:#399;font-weight:bold;'>" + item.starRating + ' Stars</div>';
    const htmlr =
      '<div>This star rating is provided to Seychelles.com by the Seychelles Tourism Department and is determined by the Seychelles Tourism Grading Programme.</div>';

    return html + htmlr;
  }

  selectAmentments(amentmentType: any) {
    this.refamentsList = [];
    for (var i = 0; i < this.selectedFacilities.length; i++) {
      this.refamentsList.push(this.selectedFacilities[i].name);
    }
    //   this.searchByValue(this.refamentsList);
  }
  // moreIslands() {
  //   this.isLandTypes = [
  //     ...this.isLandTypes,
  //     { id: 'anonyme', name: 'Anonyme Island' },
  //     { id: 'aride', name: 'Aride Island' },
  //     { id: 'beacon', name: 'Beacon Island' },
  //     { id: 'bird', name: 'Bird Island' },
  //     { id: 'test2', name: 'Booby Island' },
  //     { Id: 'test3', name: 'Cerf Island' },
  //     { Id: 'test1', name: 'Chauve Souris (Praslin) Island' },
  //     { Id: 'test2', name: 'Conception Island' },
  //     { Id: 'test3', name: 'Cousin Island' },
  //     { Id: 'test1', name: 'Curieuse Island' },
  //     { Id: 'test2', name: 'Mammelles Island' },
  //     { Id: 'test3', name: 'Marianne Island' },
  //     { Id: 'test1', name: 'Moyenne Island' },
  //   ];
  //   this.moreIsland = false;
  // }
  // moreAmmentments() {
  //   this.amentisTypes = [
  //     ...this.amentisTypes,
  //     { id: 'test1', name: 'test1' },
  //     { id: 'test2', name: 'test2' },
  //     { id: 'test3', name: 'test3' },
  //   ];
  //   this.moreAmendments = false;
  // }
  selectIsLand(isLandType: any) {
    this.refIslandList = [];
    for (var i = 0; i < this.selectedIslands.length; i++) {
      this.refIslandList.push(this.selectedIslands[i].name);
    }
    //    this.searchByValue(this.refIslandList);
  }

  selectedlandCategory(landCategory: any) {
    this.reflandCatType = [];
    for (var i = 0; i < this.selectedlandCategorys.length; i++) {
      this.reflandCatType.push(this.selectedlandCategorys[i].name);
    }
  }

  viewMoreDetils(productId: number) {
    //   this.router.navigateByUrl('/').then((result) => {
    //  const [rest, path] = this.currentUrl.split('?');
    // if (productId) {
    var url = '/listingdetails/' + productId;
    window.open(url, '_blank');
    // window.open(`/listingdetails/${productId}`, '_blank');
    //}
    //this.router.navigateByUrl(this.currentUrl);
    // });
  }

  ViewMoreRecord() {
    this.pageNumber = this.pageNumber + 1;
    // this.router.navigate used for dispaly page number
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { pge: this.pageNumber },
      queryParamsHandling: 'merge',
    });
    const lastRecordElement = this.productsList.nativeElement.lastElementChild;
    const fixedHeaderHeight = 80;
    const nextScrollTop = lastRecordElement.offsetTop + lastRecordElement.offsetHeight - fixedHeaderHeight;
    this.searchByValue(this.pageNumber, true).then(() => {
      document.documentElement.scrollTo({ top: nextScrollTop, left: 0, behavior: 'smooth' });
    });
  }

  toggleFilter() {
    const element = document.getElementById('filterSection');
    element.classList.toggle('expanded');
  }

  async getAttributes() {
    await this.searchService.getAttributes().then((data) => {
      this.attributesDes = data[0].Attributes;
    });
  }

  onCategoryClick(category: string[], index: number) {
    this.selectedCategory = category;
    this.activeIndex = index;

    this.selectedCategorieName = category.join(',');

    // ensure att is always set
    if (!this.selectedTag) {
      this.selectedTag = 'TAGCreole-Rendezvous';
    }

    this.pageNumber = 1;

    console.log('API PARAMS =>', {
      cats: this.selectedCategorieName,
      att: this.selectedTag,
    });

    this.searchByValue(this.pageNumber);
  }
}
